import App from "./App";
import Homepage from "./Homepage";
import TestEditor from "./TestEditor";
import LearningPage from "~/containers/LearningPage";

export {
    App,
    Homepage,
    TestEditor,
    LearningPage
}


// WEBPACK FOOTER //
// ./src/containers/index.ts